import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/_staff/opportunity-management',
)({
  beforeLoad: () => {
    throw redirect({
      to: '/issue-management',
    })
  },
})
